import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { isEmpty } from 'lodash/fp';
import DescriptiveAnswers from './DescriptiveAnswers';

const S = {
  ExpandMore: styled(ExpandMore)`
    margin-left: 2px;
    color: ${({ theme }) => theme.palette.grey[500]};
    font-size: 1.25rem;
  `,
  ExpandLess: styled(ExpandLess)`
    margin-left: 2px;
    color: ${({ theme }) => theme.palette.grey[500]};
    font-size: 1.25rem;
  `,
  Title: styled.p`
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 8px;
    padding: 6px 8px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  `,
  ExpandButton: styled(Button)`
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 8px;
    display: flex;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  `,
};

const OtherAnswers = ({
  stats, className,
}) => {
  const [visibleAnswers, setVisibleAnswers] = useState(true);
  const handleExpandAnswers = useCallback(() => setVisibleAnswers(prevVisibleAnswers => !prevVisibleAnswers), []);

  return (
    <div className={className}>
      {isEmpty(stats)
        ? (
          <S.Title>
            기타 의견이 없습니다
          </S.Title>
        ) : (
          <>
            <S.ExpandButton type="button" onClick={handleExpandAnswers}>
              {'기타 의견'}
              {visibleAnswers ? <S.ExpandLess /> : <S.ExpandMore />}
            </S.ExpandButton>
            {visibleAnswers
              ? <DescriptiveAnswers stats={stats} />
              : null}
          </>
        )}
    </div>
  );
};

OtherAnswers.propTypes = {
  className: PropTypes.string,
  stats: PropTypes.objectOf(PropTypes.number),
};

OtherAnswers.defaultProps = {
  className: undefined,
  stats: undefined,
};

export default OtherAnswers;
